export default __webpack_public_path__ + "static/media/scritta.b040393d.svg";